export default __webpack_public_path__ + "static/symbol-wheel-b6a30a29b3960f0f06b761ba6d14eba1.png";